import { common } from '@mui/material/colors'
import { darken, lighten, alpha } from '@mui/material'
import { isValidHex } from 'utils/validations'

export const getHoverBackgroundColor = (color, mode) => (mode === 'dark' ? darken(color, 0.6) : lighten(color, 0.1))

// Ideally we should create a dark theme palette or use useColorScheme
export const convertToDarkModeColor = color => {
  // Match the rgba pattern (rgba(0, 0, 0, x)) and extract alpha
  const regex = /rgba\((\d+), (\d+), (\d+), ([\d.]+)\)/
  const match = color.match(regex)

  if (match) {
    const alpha = match[4] // Get the alpha (opacity) value
    return `rgba(255, 255, 255, ${alpha})`
  }

  return color // If the format doesn't match, return the original color
}

export const getColorWithOpacity = (color, opacity) => alpha(color, opacity)

export const getFormattedColorAndContrastColor = (color, theme) => {
  const formattedColor = isValidHex(color) ? color : common.black
  const contrastColor = theme.palette.getContrastText(formattedColor)
  return { formattedColor, contrastColor }
}
